import common from './common.json';
import createBookingRules from './create-booking-rules.json';
import details from './details.json';

export default {
  common,
  createBookingRules,
  details,
};
